











































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { PropostaLavoroInfo } from "../../_models/propostaLavoroInfo";
import { readEnterpriseInfo } from "../../_store/user.module";
import { ArticolazioneInfo } from "../../_models/articolazioneInfo";
import 'codemirror/lib/codemirror.css';
// @ts-ignore
import '@toast-ui/editor/dist/toastui-editor.css';
// @ts-ignore
import { Editor } from '@toast-ui/vue-editor';

@Component({
	components: {
		Editor
	}
})
export default class JobOfferIstitutoCreate extends Vue {
	private titoloProposta: string;
	private descrizioneProposta: string;
	private tipoContratto: string;
	private disponibilità: string;
	private sedeLavoro: string;
	private ruolo: string;
	private competenze: string;
	private emailContattoAzienda: string;
	private telefonoContattoAzienda: string;
	private istituto: number;
	private articolazione: string;
	private azienda: number;
	private aziendaDenominazione: string;
	private denominazioneAziendaVisibile: boolean;

	private editorText: string;
	private viewerText: string;
	private editorOptions: any;

	private idCapComuneSedeLavoro: number;
	private idTipoContratto: number;
	private tipiContratti: any[];
	private comuni: any[];
	private istituti: any[];
	private aziende: any[];
	private listaArticolazioni: ArticolazioneInfo[];

	private searchComuni: object | null;
	private isLoadingComuni: boolean;
	private isLoadingInitialData: boolean;

	private searchTipiContratto: object | null;
	private isLoadingTipiContratto: boolean;

	private titoloRules: [boolean | string];
	private descrizioneRules: [boolean | string];
	private tipoRules: [boolean | string];
	private disponibilitàRules: [boolean | string];
	private sedeRules: [boolean | string];
	private ruoloRules: [boolean | string];
	private competenzeRules: [boolean | string];
	private emailContattoAziendaRules: [boolean | string];
	private telefonoContattoAziendaRules: [boolean | string];
	private articolazioneRules: [boolean | string];
	private istitutoRules: [boolean | string];
	private aziendaRules: [boolean | string];
	private aziendaDenominazioneRules: [boolean | string];

	constructor() {
		super();
		this.titoloProposta = "";
		this.descrizioneProposta = "";
		this.tipoContratto = "";
		this.disponibilità = "";
		this.sedeLavoro = "";
		this.ruolo = "";
		this.competenze = "";
		this.tipiContratti = [];
		this.comuni = [];
		this.istituti = [];
		this.aziende = [];
		this.emailContattoAzienda = "";
		this.telefonoContattoAzienda = "";
		this.aziendaDenominazione = "";

		this.titoloRules = [true];
		this.descrizioneRules = [true];
		this.tipoRules = [true];
		this.disponibilitàRules = [true];
		this.sedeRules = [true];
		this.ruoloRules = [true];
		this.competenzeRules = [true];
		this.emailContattoAziendaRules = [true];
		this.telefonoContattoAziendaRules = [true];
		this.articolazioneRules = [true];
		this.istitutoRules = [true];
		this.aziendaRules = [true];
		this.aziendaDenominazioneRules = [true];

		this.searchComuni = null;
		this.isLoadingComuni = false;
		this.isLoadingInitialData = true;
		this.idCapComuneSedeLavoro = 0;

		this.searchTipiContratto = null;
		this.isLoadingTipiContratto = false;
		this.idTipoContratto = 0;
		this.istituto = 0;
		this.azienda = 0;
		this.denominazioneAziendaVisibile = false;
		this.listaArticolazioni = [];
		this.articolazione = "";
		this.editorText = "";
		this.viewerText = "";
		this.editorOptions = {
			minHeight: '200px',
			language: 'it-IT',
			useCommandShortcut: true,
			usageStatistics: true,
			hideModeSwitch: false,
			toolbarItems: [
				['heading', 'bold', 'italic', 'strike'],
				// ['hr', 'quote'],
				['ul', 'ol', 'task', 'indent', 'outdent'],
				// ['table', 'image', 'link'],
				// ['code', 'codeblock'],
				// ['scrollSync'],
			]
		}
	}

	validazioneTitolo() {
		var valid: boolean = false;
		if (this.titoloProposta !== "") {
			valid = /^[a-zA-Z0-9ìèéùòà,.:/()'\x20]{2,100}$/.test(this.titoloProposta);
		}
		if (valid) {
			this.titoloRules = [true];
		} else if (this.titoloProposta === "") {
			this.titoloRules = ["Titolo proposta necessario"];
		} else {
			this.titoloRules = [
				"Titolo proposta deve essere compreso tra 2 e 100 caratteri e non deve contenere caratteri speciali"
			];
		}
	}

	getHml() {
		//@ts-ignore
		let html = this.$refs.toastuiEditor.invoke('getMarkdown');
		this.viewerText = html;
	}

	validazioneRuolo() {
		var valid: boolean = false;
		if (this.ruolo !== "") {
			valid = /^[a-zA-Z0-9ìèéùòà,.;:/()'\x20]{2,100}$/.test(this.ruolo);
		}
		if (valid) {
			this.ruoloRules = [true];
		} else if (this.ruolo === "") {
			this.ruoloRules = ["Ruolo necessario"];
		} else {
			this.ruoloRules = ["Ruolo deve essere compreso tra 2 e 100 caratteri e non deve contenere caratteri speciali"];
		}
	}
	// valiazioneCompetenze() {

	//   // var valid: boolean = false;
	//   // if (this.competenze !== "") {
	//   //   valid = /^[a-zA-Z0-9ìèéùòà'.,;\x20-]{2,500}$/.test(this.competenze);
	//   // }
	//   // if (valid) {
	//   //   this.competenzeRules = [true];
	//   // } else if (this.competenze === "") {
	//   //   this.competenzeRules = ["Competenze necessarie"];
	//   // } else {
	//   //   this.competenzeRules = [
	//   //     "Competenze deve essere compreso tra 2 e 500 caratteri"
	//   //   ];
	//   // }
	// }
	valiazioneDescrizione() {
		var valid: boolean = false;
		if (this.descrizioneProposta !== "") {
			valid = /^[a-zA-Z0-9ìèéùòà,.();:/'\x20]{2,500}$/.test(
				this.descrizioneProposta
			);
		}
		if (valid) {
			this.descrizioneRules = [true];
		} else if (this.descrizioneProposta === "") {
			this.descrizioneRules = ["Descrizione proposta necessaria"];
		} else {
			this.descrizioneRules = [
				"Descrizione proposta deve essere compresa tra 2 e 500 caratteri e non deve contenere caratteri speciali e spazi a capo"
			];
		}
	}
	validazioneTipoContratto() {
		var valid: boolean = false;
		if (this.tipoContratto !== "") {
			valid = /^[a-zA-Z0-9ìèéùòà,.;:()/'\x20]{2,100}$/.test(this.tipoContratto);
		}
		if (valid) {
			this.tipoRules = [true];
		} else if (this.tipoContratto === "") {
			this.tipoRules = ["Tipo Contratto necessario"];
		} else {
			this.tipoRules = [
				"Tipo Contratto deve essere compreso tra 2 e 100 caratteri e non deve contenere caratteri speciali"
			];
		}
	}
	validazioneDisponibilità() {
		if (this.disponibilità === "") {
			this.disponibilitàRules = ["Disponibilità necessaria"];
		} else {
			this.disponibilitàRules = [true];
		}
	}
	validazioneSede() {
		// if (this.idCapComuneSedeLavoro === 0) {
		//   this.sedeRules = ["Sede lavoro necessaria"];
		// } else {
		//   this.sedeRules = [true];
		// }
		var valid: boolean = false;
		if (this.sedeLavoro !== "") {
			valid = /^[a-zA-Z0-9ìèéùòà,.;:'\x20]{2,50}$/.test(this.sedeLavoro);
		}
		if (valid) {
			this.sedeRules = [true];
		} else if (this.sedeLavoro === "") {
			this.sedeRules = ["Sede lavoro necessaria"];
		} else {
			this.sedeRules = [
				"Sede lavoro deve essere compresa tra 2 e 50 caratteri"
			];
		}
	}

	validazioneEmail() {
		var valid: boolean = false;
		if (this.emailContattoAzienda !== "") {
			valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
				this.emailContattoAzienda
			);
		}
		if (valid) {
			this.emailContattoAziendaRules = [true];
		} else if (this.emailContattoAzienda === "") {
			this.emailContattoAziendaRules = ["Email di riferiemnto necessaria"];
		} else {
			this.emailContattoAziendaRules = ["Formato Email non corretto"];
		}
	}

	validazioneTel() {
		var valid: boolean = false;
		if (this.telefonoContattoAzienda !== "") {
			valid = /[0-9]{8,15}$/.test(this.telefonoContattoAzienda);
		}
		if (valid) {
			this.telefonoContattoAziendaRules = [true];
		} else if (this.telefonoContattoAzienda === "") {
			this.telefonoContattoAziendaRules = [
				"Telefono di riferiemnto necessario"
			];
		} else {
			this.telefonoContattoAziendaRules = [
				"Il numero di telefono non ha un formato corretto"
			];
		}
	}

	validazioneArticolazione() {
		if (this.articolazione !== "") {
			this.articolazioneRules = [true];
		} else {
			this.articolazioneRules = ["Specificare Settore di appartenenza"];
		}
	}

	validazioneIstituto() {
		if (this.istituto !== 0) {
			this.istitutoRules = [true];
		} else {
			this.istitutoRules = [
				"Specificare Istituto per cui si vuole creare l'offerta"
			];
		}
	}

	validazioneAzienda() {
		if ((this.azienda && this.azienda !== 0) || 
			(this.aziendaDenominazione && this.aziendaDenominazione.trim() !== "")) {
			this.aziendaRules = [true];
			this.aziendaDenominazioneRules = [true];
		} else {
			this.aziendaRules = [
				"Specificare Azienda per cui si vuole creare l'offerta"
			];
			this.aziendaDenominazioneRules = [
				"Specificare Azienda per cui si vuole creare l'offerta"
			];
		}
	}

	onAziendaBlur() {
		if (this.azienda && this.azienda !== 0) {
			this.aziendaDenominazione = "";
			this.aziendaDenominazioneRules = [true];
		}
		this.validazioneAzienda();
	}

	onAziendaDenominazioneBlur() {
		if (this.aziendaDenominazione && this.aziendaDenominazione.trim() !== "") {
			this.azienda = 0;
			this.aziendaRules = [true];
			const valid = /^[a-zA-Z0-9ìèéùòà,.;:()/'\x20]{2,100}$/.test(this.aziendaDenominazione);
			if (valid) {
				this.aziendaDenominazioneRules = [true];
			} else {
				this.aziendaDenominazioneRules = [
					"Denominazione deve essere compresa tra 2 e 100 caratteri e non deve contenere caratteri speciali"
				];
			}
		}
		this.validazioneAzienda();
	}

	close() {
		this.titoloProposta = "";
		this.descrizioneProposta = "";
		this.tipoContratto = "";
		this.disponibilità = "";
		this.sedeLavoro = "";
		this.ruolo = "";
		this.competenze = "";
		this.tipiContratti = [];
		this.emailContattoAzienda = "";
		this.telefonoContattoAzienda = "";
		this.istituto = 0;
		this.azienda = 0;
		this.aziendaDenominazione = "";
		this.denominazioneAziendaVisibile = false;
		this.listaArticolazioni = [];
		this.articolazione = "";

		this.editorText = "";
		this.viewerText = "";

		this.titoloRules = [true];
		this.descrizioneRules = [true];
		this.tipoRules = [true];
		this.disponibilitàRules = [true];
		this.sedeRules = [true];
		this.ruoloRules = [true];
		this.competenzeRules = [true];
		this.emailContattoAziendaRules = [true];
		this.telefonoContattoAziendaRules = [true];
		this.articolazioneRules = [true];
		this.istitutoRules = [true];
		this.aziendaRules = [true];
		this.aziendaDenominazioneRules = [true];
		bus.$emit("closeCreateDialog");
	}

	async executeTest() {
		this.validazioneTitolo();
		this.validazioneRuolo();
		// this.valiazioneCompetenze();
		this.valiazioneDescrizione();
		this.validazioneTipoContratto();
		this.validazioneDisponibilità();
		this.validazioneSede();
		this.validazioneEmail();
		this.validazioneTel();
		this.validazioneArticolazione();
		this.validazioneIstituto();
		this.validazioneAzienda();
	}

	save() {
		this.getHml()
		if (this.viewerText !== "") {
			this.executeTest().then(() => {
				if (this.idCapComuneSedeLavoro !== 0) {
					if (
						(this.$refs.form as Vue & {
							validate: () => boolean;
						}).validate()
					) {
						var payload: PropostaLavoroInfo = {
							idProposta: 0,
							idAzienda: this.azienda || 0,
							denominazioneAzienda: "",
							denominazioneAziendaMan: this.aziendaDenominazione || "",
							denominazioneAziendaVisibile: this.denominazioneAziendaVisibile,
							nomeProposta: this.titoloProposta,
							tipoContratto: this.tipoContratto,
							descrizioneContratto: "",
							idCapProposta: this.idCapComuneSedeLavoro,
							comuneProposta: "",
							provinciaProposta: "",
							indirizzoProposta: this.sedeLavoro,
							descrizioneProposta: this.descrizioneProposta,
							disponibile: true,
							ruolo: this.ruolo,
							competenze: this.viewerText,
							sede: "",
							emailContattoAzienda: this.emailContattoAzienda,
							telefonoContattoAzienda: this.telefonoContattoAzienda,
							idIstituto: this.istituto,
							idArticolazione: this.articolazione,
							nomeIstituto: "",
							nomeArticolazione: "",
							candidature: false,
							dataCreazione: "",
							dsDataCreazione: ""
						};

						console.log(payload);

						user
							.dispatchCreatePropostaLavoro(this["$store"], payload)
							.then(() => {
								bus.$emit(
									"successfullOperation",
									"Offerta creata con successo"
								);
								this.close();
								bus.$emit("loadProposte");
							})
							.catch(error => {
								if (error.response.status === 403) {
									bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
									this["$router"].push("/login");
								} else {
									bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								}
							});
					}
				} else {
					bus.$emit("errorOperation", "Inserire Comune Sede Lavoro");
				}
			});
		} else {
			bus.$emit("errorOperation", "Inserire Competenze richieste");
		}
	}

	created() {
        var instituteInfo = user.readInstituteInfo(this["$store"]);
        this.istituto = instituteInfo.id;

		this.isLoadingInitialData = true;

		const promises = [
			this.loadArticolazioni(),
			this.loadAziende(),
			this.loadComuni()
		];

		Promise.all(promises)
		.then(() => {
			this.isLoadingInitialData = false;
		})
		.catch(() => {
			this.isLoadingInitialData = false;
		});
	}

	async loadArticolazioni() {
		this.articolazione = "";
		if (this.istituto !== 0) {
			try {
				const result = await data.dispatchArticolazioni(this["$store"], this.istituto);
				this.listaArticolazioni = result;
			} catch (error: any) {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			}
		}
	}

	async loadAziende() {
		this.azienda = 0;
		this.aziendaDenominazione = "";
		if (this.istituto !== 0) {
			try {
				const result = await data.dispatchEnterprisesList(this["$store"], { idIstituto: this.istituto });
				this.aziende = result;
			} catch (error: any) {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", "Errore nel caricamento lista azienda");
				}
			}
		}
	}

	async loadComuni() {
		try {
			const result = await data.dispatchComuniList(this["$store"]);
			var obj = {
				id: 0,
				località: "",
				idProvincia: ""
			};
			result.forEach(element => {
				if (element.id !== 0) {
					obj = {
						id: element.id,
						località: element.località,
						idProvincia: element.idProvincia
					};
					this.comuni.push(obj);
				}
			});
		} catch (error) {
			bus.$emit(
				"errorOperation",
				"Errore nel caricamento della lista comuni"
			);
		}
	}
}
